// Společné texty o autorovi, datech a období – jedno místo pro celý web.
export const SITE_URL = "https://finpilot.cz";
export const DATA_UPDATED = "2026-10-03";
export const DATA_UPDATED_LABEL = "říjen 2026";
export const STATS_PERIOD = "2023–2025";
export const FIRMS_COUNT_LABEL = "více než 25 000";

export const AUTHOR = {
  name: "Ing. Ivan Bázin",
  role: "investiční analytik, Genesis Capital",
  past: "dříve M&A analytik a advisor v poradenské společnosti Galik In",
  url: `${SITE_URL}/o-projektu`,
};

export const GALIKIN_URL = "https://galikin.cz";

// Zdroj dat – formulace pro web (veřejné účetní závěrky, vlastní zpracování).
export const DATA_SOURCE_SHORT =
  "Statistiky vycházejí z účetních závěrek, které české firmy zveřejňují ve Sbírce listin obchodního rejstříku (justice.cz).";

export const authorSchema = {
  "@type": "Person",
  name: AUTHOR.name,
  jobTitle: "Investiční analytik",
  url: AUTHOR.url,
};

export const publisherSchema = {
  "@type": "Organization",
  name: "FinPilot",
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
};

// čitelné názvy sekcí CZ-NACE (ve statistice jsou verzálkami s předponou „SEKCE X -“)
export const SECTION_NAMES = {
  A: "Zemědělství, lesnictví a rybářství", B: "Těžba a dobývání", C: "Zpracovatelský průmysl", D: "Výroba a rozvod energií",
  E: "Voda, odpady a sanace", F: "Stavebnictví", G: "Velkoobchod a maloobchod", H: "Doprava a skladování",
  I: "Ubytování, stravování a pohostinství", J: "Informační a komunikační činnosti", K: "Peněžnictví a pojišťovnictví",
  L: "Činnosti v oblasti nemovitostí", M: "Profesní, vědecké a technické činnosti", N: "Administrativní a podpůrné činnosti",
  P: "Vzdělávání", Q: "Zdravotní a sociální péče", R: "Kulturní, zábavní a rekreační činnosti", S: "Ostatní činnosti",
};
